import {
  AVAILABILITY,
  BLOCKAGE,
  EXTRA_TYPE_VARIANT,
  GUEST_TYPE,
  RATE_TYPE_NEW,
  RESTRICTIONS_TYPE,
  StayDaysFilterType,
} from "../../../Common/constants";

export default {
  locale: "es",
  name: "Extras",
  translation: { displayName: "Traducciones" },
  tabs: [
    {
      title: "Propiedades",
    },
    {
      title: "Imágenes",
    },
    {
      title: "Código de uso único",
      hideSubmitButton: true,
    },
  ],
  fields: {
    list: [
      {
        fieldName: "active",
        displayName: "Activo",
      },
      {
        fieldName: "ticker",
        displayName: "Identificador",
        helpText: "Caracteres máximos: 8",
      },
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "type",
        displayName: "Tipo",
      },
      {
        fieldName: "rate",
        displayName: "Tarifa",
      },
      {
        fieldName: "validity",
        displayName: "Validez (fechas)",
      },
      {
        fieldName: "availability",
        displayName: "Disponibilidad",
      },
      {
        fieldName: "blocking",
        displayName: "Bloq. Validez",
      },
      {
        fieldName: "lockType",
        displayName: "Tipo Bloqueo",
      },
      {
        fieldName: "confirmationEmailReceivers",
        displayName: "Email",
      },
      {
        fieldName: "minStay",
        displayName: "Est.mín.(d)",
      },
      {
        fieldName: "maxStay",
        displayName: "Est. máx(d)",
      },
      {
        fieldName: "minNotice",
        displayName: "Rel. mín(h)",
      },
      {
        fieldName: "maxNotice",
        displayName: "Rel. máx(h)",
      },
      {
        fieldName: "promoCode",
        displayName: "Código",
      },
      {
        fieldName: "excludedRooms",
        displayName: "Excluídas",
      },
    ],
    form: [
      {
        fieldName: "isActive",
        displayName: "Activo",
      },
      {
        fieldName: "ticker",
        displayName: "Identificador",
      },
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "description",
        displayName: "Descripción",
      },
      {
        fieldName: "ratesSection",
        displayName: "Tarifa",
        widget: "section",
      },

      {
        fieldName: "rateType",
        displayName: "Tarifas",
        optionDisplay: {
          "": {
            label: "",
          },
          [RATE_TYPE_NEW.CONSTANT]: {
            label: "Constante",
          },
          [RATE_TYPE_NEW.OWN]: {
            label: "Propio/a",
          },
        },
      },
      {
        fieldName: "type",
        displayName: "Tipo",
        optionDisplay: {
          [EXTRA_TYPE_VARIANT.ROOM]: {
            label: "Por habitación",
          },
          [EXTRA_TYPE_VARIANT.ROOM_PER_DAY]: {
            label: "Por habitación/día",
          },
          [EXTRA_TYPE_VARIANT.ROOM_MANDATORY]: {
            label: "Por habitación (Obligatorio)",
          },
          [EXTRA_TYPE_VARIANT.ROOM_PER_DAY_MANDATORY]: {
            label: "Por habitación/día (Obligatorio)",
          },
          [EXTRA_TYPE_VARIANT.ROOM_SPECIFIC_DATE]: {
            label: "Por habitación/fechas especificas",
          },
          [EXTRA_TYPE_VARIANT.PERSON]: {
            label: "Por persona",
          },
          [EXTRA_TYPE_VARIANT.PERSON_PER_DAY]: {
            label: "Por persona/día",
          },
          [EXTRA_TYPE_VARIANT.PERSON_MANDATORY]: {
            label: "Por persona (Obligatorio)",
          },
          [EXTRA_TYPE_VARIANT.PERSON_PER_DAY_MANDATORY]: {
            label: "Por persona/día (Obligatorio)",
          },
          [EXTRA_TYPE_VARIANT.PERSON_SPECIFIC_DATE]: {
            label: "Por persona/fechas especificas",
          },
          [EXTRA_TYPE_VARIANT.UNIT]: {
            label: "Unitario",
          },
          [EXTRA_TYPE_VARIANT.UNIT_PER_DAY]: {
            label: "Unitario/día",
          },
          [EXTRA_TYPE_VARIANT.UNIT_SPECIFIC_DATE]: {
            label: "Unitario/fechas especificas",
          },
        },
      },
      {
        fieldName: "stayDaysFilterType",
        displayName: "Aplica a:",
        optionDisplay: {
          [StayDaysFilterType.ALL_STAY_DAYS_EXCEPT_CHECKOUT]: {
            label: "Todos los días de estancia excepto check-out",
          },
          [StayDaysFilterType.ALL_STAY_DAYS_EXCEPT_CHECKIN]: {
            label: "Todos los días de estancia excepto check-in",
          },
          // [StayDaysFilterType.ALL_STAY_DAYS_EXCEPT_CHECKIN_AND_CHECKOUT]: {
          //   label: "Todos los días de estancia excepto check-in y check-out",
          // },
          [StayDaysFilterType.ONLY_CHECKIN]: {
            label: "Sólo check-in",
          },
          // [StayDaysFilterType.ONLY_CHECKOUT]: {
          //   label: "Sólo check-out",
          // },
        },
      },
      {
        fieldName: "availabilityType",
        displayName: "Disponibilidad",
        widget: "selector",
        optionDisplay: {
          "": {
            label: "--",
          },
          [`AVAILABILITY_${AVAILABILITY.OWN}`]: {
            label: "Propio/a",
          },
        },
        defaultValue: "",
      },
      {
        fieldName: "blockingType",
        displayName: "Bloqueo",
        optionDisplay: {
          "": {
            label: "--",
          },
          [BLOCKAGE.OWN]: {
            label: "Propio/a",
          },
        },
      },
      {
        fieldName: "blockingValue",
        widget: "selector",
        transform: ({ entity, field }) => ({
          ...field,
          optionDisplay:
            entity &&
            entity.blockingValues &&
            entity.blockingValues.reduce((accum, it) => ({ ...accum, [it]: { label: it } }), {
              "": { label: "Elegir líneas de inventario" },
            }),
        }),
      },

      {
        fieldName: "lockType",
        displayName: "Comportamiento de bloqueo y disponibilidad",
        optionDisplay: {
          [EXTRA_TYPE_VARIANT.LOCK_TYPE_DAY]: {
            label: "Por día",
          },
          [EXTRA_TYPE_VARIANT.LOCK_TYPE_STAY]: {
            label: "Por estancia",
          },
        },
      },
      {
        fieldName: "appliesToGuests",
        displayName: "Se aplica a",
        transform: ({ formValues, field }) => {
          return {
            ...field,
            options: [
              {
                ticker: GUEST_TYPE.ADULT,
                name: "ADULTO",
              },
              {
                ticker: GUEST_TYPE.CHILD,
                name: "NIÑO",
              },
              {
                ticker: GUEST_TYPE.BABY,
                name: "BEBÉ",
              },
              {
                ticker: GUEST_TYPE.TEENAGER,
                name: "JUNIOR",
              },
              {
                ticker: GUEST_TYPE.SENIOR,
                name: "SENIOR",
              },
            ],
          };
        },
      },
      {
        fieldName: "maxBookableUnits",
        displayName: "Máx. uds.",
      },
      {
        fieldName: "codeSection",
        displayName: "Código promocional/empresa",
        widget: "section",
      },
      {
        fieldName: "promoCode",
        displayName: "Id. promoción",
      },
      {
        fieldName: "validitySection",
        displayName: "Validez",
      },
      {
        fieldName: "validFrom",
        displayName: "Fecha inicio",
      },
      {
        fieldName: "validTo",
        displayName: "Fecha fin",
      },
      {
        fieldName: "minStayType",
        displayName: "Estancia mínima (días)",
        optionDisplay: {
          [RESTRICTIONS_TYPE.NO_LIMIT]: {
            label: "Sin Límite",
          },
          [RESTRICTIONS_TYPE.CONSTANT]: {
            label: "Constante",
          },
        },
      },
      {
        fieldName: "minStayValue",
      },
      {
        fieldName: "maxStayType",
        displayName: "Estancia máxima (días)",
        optionDisplay: {
          [RESTRICTIONS_TYPE.NO_LIMIT]: {
            label: "Sin Límite",
          },
          [RESTRICTIONS_TYPE.CONSTANT]: {
            label: "Constante",
          },
        },
      },
      {
        fieldName: "maxStayValue",
      },
      {
        fieldName: "minNoticeType",
        displayName: "Antelación mínima (horas)",
        optionDisplay: {
          [RESTRICTIONS_TYPE.NO_LIMIT]: {
            label: "Sin Límite",
          },
          [RESTRICTIONS_TYPE.CONSTANT]: {
            label: "Constante",
          },
        },
      },
      {
        fieldName: "minNoticeValue",
      },
      {
        fieldName: "maxNoticeType",
        displayName: "Antelación máxima (horas)",
        optionDisplay: {
          [RESTRICTIONS_TYPE.NO_LIMIT]: {
            label: "Sin Límite",
          },
          [RESTRICTIONS_TYPE.CONSTANT]: {
            label: "Constante",
          },
        },
      },
      {
        fieldName: "maxNoticeValue",
      },
      {
        displayName: "Lista emails",
        fieldName: "emailSection",
      },
      {
        fieldName: "confirmationEmailReceivers",
        displayName: "Receptores de confirmación de reserva",
      },
      {
        fieldName: "roomsWithExtrasSection",
        displayName: "Habitaciones con el extra habilitado",
      },
      {
        fieldName: "imageManagementSection",
        displayName: "Gestión de imágenes",
      },
      {
        fieldName: "appliesTo",
        filterNames: ["Alojamiento", "Condiciones", "Configuraciones", "Pensiones"],
      },
      {
        fieldName: "notificationEmails",
        displayName: "Receptores de confirmación de reserva",
      },
      {
        fieldName: "active",
        displayName: "Activo",
      },
      {
        fieldName: "infoMessage",
        value:
          "Para activar códigos de un solo uso debes guardar un extra primero y acceder de nuevo para editar.",
      },
    ],
  },
  validation: {
    minStayValue: {
      constraints: {
        numericality: {
          message: "No es un número",
        },
      },
    },
    maxStayValue: {
      constraints: {
        numericality: {
          message: "No es un número",
        },
      },
    },
    minNoticeValue: {
      constraints: {
        numericality: {
          message: "No es un número",
        },
      },
    },
    maxNoticeValue: {
      constraints: {
        numericality: {
          message: "No es un número",
        },
      },
    },
  },
};
